/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Alert,
  Checkbox,
  Collapse,
  Input,
  Select,
  Spin,
  // TimePicker,
} from 'antd';
import { Page, Breadcrumb, ResponseDialog } from '../../components';
import './supplyWizard.scss';
import SupplierActions from '../../redux/middleware/supplier';
// import type { Dayjs } from 'dayjs';
import Utils from '../../redux/utils';
import { checkAuthentication } from '../../helper/checkAuthentication';

const SupplyWizard = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { Panel } = Collapse;
  const { update, id } = state;
  const [visible, setVisible] = useState(false);
  // const [supplierAlert, setSupplierAlert] = useState(false);
  const [apiLoader, setApiLoader] = useState(false);
  const [supplierCode, setSupplierCode] = useState<any>();
  const [company, setCompany] = React.useState('' as any);
  const [address, setAddress] = React.useState('' as any);
  const [city, setCity] = useState<any[]>([]);
  const [isDaySelected, setIsDaySelected] = useState('');
  const [phone, handlePhone] = React.useState('' as any);
  const [supplierEmail, setSupplierEmail] = React.useState('');
  const [supplierName, setSupplierName] = React.useState('');
  const [errorList, setErrorList] = useState<any>({});
  const [errorStatus, setErrorStatus] = React.useState(false);
  const [blocked] = useState(true);
  const [cityList, setCityList] = useState<any[]>([]);
  const user = Utils.getCurrentUser();
  // const company_name = user?.company_name;
  const country_name = user?.country_name;
  const [errorMessage] = useState<any[]>([]);
  const [error, setError] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [countryCode, setCountryCode] = useState(
    Utils.getCurrentUser()?.country_code
  );
  // const [checkedValues, setCheckedValues] = useState<any>([]);
  const [deliveryTimes, setDeliveryTimes] = useState<any[]>([]);

  const options = [
    { label: 'Monday', value: 'Monday' },
    { label: 'Tuesday', value: 'Tuesday' },
    { label: 'Wednesday', value: 'Wednesday' },
    { label: 'Thursday', value: 'Thursday' },
    { label: 'Friday', value: 'Friday' },
    { label: 'Saturday', value: 'Saturday' },
    { label: 'Sunday', value: 'Sunday' },
  ];
  const hours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ];
  const handleBack = () => {
    navigate('/app/supply');
  };

  const getCitiesListing = async () => {
    const response = await SupplierActions.getSupplierCity();
    if (response?.success) {
      const { data } = response;
      const list =
        data &&
        data.map((item: any) => ({
          value: item?.shop_id,
          key: item?.id,
          label: item?.shop_name + '  -  ' + item?.city,
        }));
      setCityList(list);
    }
  };

  const handleCityId = (id: any) => {
    const data: any = id.map((data: any) => {
      return cityList.filter((id: any) => {
        if (id.value == data) {
          return id;
        }
      });
    });
    const filteredCities = data.flat();
    setCity(filteredCities);
    // if (!company.trim() && filteredCities.length > 0) {
    //   setSupplierAlert(true);
    // } else {
    //   setSupplierAlert(false);
    // }
  };

  const getSupplierInfo = async (id: any) => {
    const response = await SupplierActions.getSupplierById(id);
    if (response?.success) {
      const { data } = response;
      if (data) {
        setApiLoader(false);
      }

      setSupplierEmail(data[0]?.email);
      handlePhone(data[0]?.phone);
      setSupplierName(data[0]?.supplier_name);
      setSupplierCode(data[0]?.supplier_code);
      setCompany(data[0]?.contact_name);
      setAddress(data[0]?.address);
      setDeliveryTimes(data[0]?.delivery_timings);
      setCity(
        data[0]?.city_id?.map((data: any) => {
          return {
            ...data,
            label: data?.shop_name + '  -  ' + data?.city,
            // value: data?.id,
            value: data?.shop_id,
            key: data?.shop_id,
          };
        })
      );
    }
  };

  React.useEffect(() => {
    checkAuthentication(user, navigate);
    getCitiesListing();
    if (update) {
      setApiLoader(true);
      getSupplierInfo(id?.id);
    }
  }, []);

  const generateRandom5DigitCode = () => {
    return Math.floor(10000 + Math.random() * 90000).toString();
  };

  const handleContinue = async () => {
    window.scrollTo(0, 0);
    setErrorList({});
    setErrorStatus(false);
    const user = await Utils.getCurrentUser();

    if (
      supplierEmail === '' ||
      address === '' ||
      supplierName === '' ||
      company === '' ||
      !phone
    ) {
      setVisible(true);
      return;
    }

    if (deliveryTimes.length < 1) {
      setErrorStatus(true);
      setErrorList((prev: any) => ({
        ...prev,
        city_id: 'Branch information is required.',
      }));
      return;
    }

    let isValid = true;
    deliveryTimes.forEach((deliveryTime: any) => {
      const { shop_id, day, start_time, end_time } = deliveryTime;
      if (!shop_id || !day || !start_time || !end_time) {
        setErrorStatus(true);
        setErrorList((prev: any) => ({
          ...prev,
          city_id: 'Branch schedule required',
        }));
        isValid = false;
      }
    });

    if (update) {
      const missingTimings = city?.some((shop: any) => {
        return !deliveryTimes.some(
          (deliveryTime: any) => deliveryTime?.shop_id === shop?.value
        );
      });

      if (missingTimings) {
        setErrorStatus(true);
        setErrorList((prev: any) => ({
          ...prev,
          city_id: 'Each branch must have delivery timings',
        }));
        return;
      }
    }

    if (!isValid) return isValid;

    const finalSupplierCode =
      !supplierCode || supplierCode.trim() === ''
        ? generateRandom5DigitCode()
        : supplierCode;

    const payload = {
      supplier_code: finalSupplierCode,
      contact_name: company,
      supplier_name: supplierName,
      phone: phone,
      email: supplierEmail,
      address: address,
      company_id: user?.company_id,
      brand_id: Utils.getCurrentBrand()?.brand_id,
      country_id: user?.country_id,
      shops: city?.map((data: any) => {
        return {
          city_id: data?.city_id || data?.key,
          shop_id: data?.value,
        };
      }),
      delivery_timings: deliveryTimes.map((deliveryTime: any) => ({
        shop_id: deliveryTime?.shop_id,
        day: deliveryTime?.day,
        start_time: deliveryTime?.start_time,
        end_time: deliveryTime?.end_time,
      })),
    };

    try {
      // let responseDialogData;

      setApiLoader(true);
      let response;
      if (update) {
        response = await SupplierActions.updateSupplier(id?.id, payload);
      } else {
        response = await SupplierActions.addSupplier(payload);
      }
      setApiLoader(false);
      if (!response?.success) {
        setErrorList(response?.error);
        setErrorStatus(true);
        // responseDialogData = {
        //   OnClick: () => {},
        //   type: 'error',
        //   messageArray: ['Validation Failed!', 'Something Went Wrong'],
        // };
        // ResponseDialog(responseDialogData);
      } else {
        navigate('/app/supply');

        // responseDialogData = {
        //   OnClick: () => {
        //     navigate('/app/supply');
        //   },
        //   type: 'success',
        //   messageArray: [
        //     ` Your supplier - ${supplierName} has been ${
        //       !update ? 'Created' : 'Updated'
        //     }`,
        //   ],
        // };
        // ResponseDialog(responseDialogData);
      }
    } catch (e) {
      console.log(e);
      let responseDialogData = {
        OnClick: () => {},
        type: 'error',
        messageArray: ['Server Error!', 'Something Went Wrong'],
      };
      ResponseDialog(responseDialogData);
    }
  };

  const onChange = (
    // time: Dayjs,
    timeString: string,
    selectedDay: any,
    label: String,
    data: any
  ) => {
    let dataArray = deliveryTimes;
    const index = deliveryTimes?.findIndex(
      (obj: any) => obj?.day == selectedDay && obj?.shop_id == data?.value
    );
    if (label == 'start_time')
      dataArray[index] = {
        ...dataArray[index],
        start_time: timeString,
      };
    else
      dataArray[index] = {
        ...dataArray[index],
        end_time: timeString,
      };
    setDeliveryTimes([...dataArray]);
  };

  const handleDeliveryTimes = (e: any, data: any, day: String) => {
    const isChecked = e.target.checked;
    setIsDaySelected(e.target.checked);
    if (isChecked) {
      setDeliveryTimes(() => [
        ...deliveryTimes,
        {
          shop_id: data?.value,
          day,
          start_time: null,
          end_time: null,
        },
      ]);
    } else {
      const index = deliveryTimes?.findIndex(
        (removeObj: any) =>
          removeObj?.day == day && removeObj?.shop_id == data?.value
      );
      const dataArray = deliveryTimes;
      dataArray.splice(index, 1);
      setDeliveryTimes([...dataArray]);
    }
  };

  const renderCheckboxGroup = (data: any) => {
    return options.map((option: any) => {
      const isDaySelected = !!deliveryTimes?.find(
        (deliveryObj: any) =>
          deliveryObj?.day === option?.label &&
          deliveryObj?.shop_id === data?.value
      );
      // const object = deliveryTimes?.find(
      //   (deliveryObj: any) =>
      //     deliveryObj?.day == option?.label && deliveryObj?.shop_id == data?.key
      // );

      const selectedStartTime = deliveryTimes?.find(
        (time: any) =>
          time?.shop_id === data?.value && time?.day === option?.value
      )?.start_time;

      const selectedEndTime = deliveryTimes?.find(
        (time: any) =>
          time?.shop_id === data?.value && time?.day === option?.value
      )?.end_time;

      return (
        <div key={data?.value + option.value} className="shopDaysContainer">
          <Checkbox
            checked={isDaySelected}
            // checked={object?.shop_id + object?.day}
            // defaultChecked
            value={data?.value + option.value}
            onChange={(e: any) => {
              handleDeliveryTimes(e, data, option.label);
            }}
            // indeterminate={true}
          >
            {option.label}
          </Checkbox>
          <div>
            {/* <TimePicker
              // use12Hours
              // defaultValue={Dayjs('12:08:23', 'HH:mm:ss')}
              value={
                deliveryTimes?.find(
                  (time: any) =>
                    time?.shop_id == data?.key && time?.day == option?.value
                )?.start_time
              }
              format="HH:mm"
              onChange={(time: any, timeString: string) =>
                onChange(time, timeString, option?.label, 'start_time', data)
              }
              placeholder="From"
            /> */}
            <Select
              // size={'large'}
              showSearch
              placeholder={'From'}
              onChange={(e) => {
                onChange(e, option?.label, 'start_time', data);
              }}
              style={{ width: 120 }}
              optionFilterProp="children"
              value={selectedStartTime}
              disabled={!isDaySelected} // Enable when day is selected
            >
              {hours?.map((hour: any, menuIndex: number) => (
                <Select.Option value={hour} key={menuIndex}>
                  {hour}
                </Select.Option>
              ))}
            </Select>
            {/* <TimePicker
              format="HH:mm"
              onChange={(time: any, timeString: string) =>
                onChange(timeString, option?.label, 'end_time', data)
              }
              placeholder="To"
              value={
                deliveryTimes?.find(
                  (time: any) =>
                    time?.shop_id == data?.key && time?.day == option?.value
                )?.end_time
              }
            /> */}
            <Select
              // size={'large'}
              showSearch
              placeholder={'To'}
              onChange={(e) => {
                onChange(e, option?.label, 'end_time', data);
              }}
              style={{ width: 120 }}
              optionFilterProp="children"
              value={selectedEndTime}
              disabled={!isDaySelected || !selectedStartTime}
            >
              {hours?.map((hour: any, menuIndex: number) => (
                <Select.Option
                  value={hour}
                  key={menuIndex}
                  disabled={selectedStartTime && hour <= selectedStartTime}
                >
                  {hour}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <Breadcrumb
        heading="Add New Supplier"
        breadcrumbIcon
        iconAction={() => {
          navigate('/app/supply');
        }}
      />
      <Spin
        size="large"
        className="loadIngredient recipeBuilderloaderHeight"
        spinning={apiLoader}
      >
        <Page title="Add New Supplier">
          {visible && (
            <Alert
              message="Error"
              description="Please complete all required fields to proceed"
              type="error"
              showIcon
              closable
              className="wizardAlert"
              afterClose={() => setVisible(false)}
            />
          )}
          {/* {supplierAlert && (
            <Alert
              message="Warning"
              description="Add supplier first"
              type="warning"
              showIcon
              closable
              className="wizardAlert"
              afterClose={() => setError(false)}
            />
          )} */}
          <div className="alertMessage">
            {error &&
              errorMessage?.map((data: any, index: any) => (
                <Alert
                  message="Error"
                  description={data}
                  type="error"
                  showIcon
                  closable
                  className="wizardAlert"
                  afterClose={() => setError(false)}
                  key={index}
                />
              ))}
          </div>

          <div className="wizardContainer supplierWizard">
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Supplier Code <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter Company name"
                size="large"
                onChange={(e) => {
                  const value = e.target.value;
                  setSupplierCode(value);
                }}
                disabled={update}
                value={supplierCode}
              />
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Supplier Name <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter Company name"
                size="large"
                onChange={(e) => {
                  const value = e.target.value;
                  setCompany(value);
                }}
                value={company}
                required
                className={
                  errorList['company_id']?.length > 0 ? 'borderRed' : ''
                }
              />
              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['company_id']}
                </div>
              )}
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Contact Name <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter contact name"
                size="large"
                value={supplierName}
                onChange={(e) => setSupplierName(e.target.value)}
                required
                className={
                  errorList['supplier_name']?.length > 0 ? 'borderRed' : ''
                }
              />

              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['supplier_name']}
                </div>
              )}
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Contact Number <span className="sterik">*</span>
              </div>
              <Input
                addonBefore={countryCode}
                placeholder="Enter Phone Number"
                type="number"
                value={phone}
                onChange={(e) => handlePhone(e.target.value)}
                className={errorList['phone']?.length > 0 ? 'borderRed' : ''}
              />
              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['phone']}
                </div>
              )}
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Contact Email <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter Email"
                size="large"
                value={supplierEmail}
                onChange={(e) => setSupplierEmail(e.target.value)}
                required
                className={errorList['email']?.length > 0 ? 'borderRed' : ''}
              />
              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['email']}
                </div>
              )}
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Address <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter Address"
                size="large"
                onChange={(e) => setAddress(e.target.value)}
                value={address}
                required
                className={errorList['address']?.length > 0 ? 'borderRed' : ''}
              />
              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['address']}
                </div>
              )}
            </div>
            <div className="wizardSubContainer">
              <div className="wizardLabel">
                Country <span className="sterik">*</span>
              </div>
              {/* <Select
                size={'large'}
                placeholder={'Select Country'}
                value={country}
                onChange={handlePickerChange('country')}
                style={{ width: 560 }}
                options={countryList}
              /> */}
              <Input
                placeholder="Enter Country name"
                size="large"
                value={country_name}
                disabled={blocked}
                required
              />
            </div>
            <div className="wizardDropdown">
              <div className="wizardLabel">
                Branch in City <span className="sterik">*</span>
              </div>
              <Select
                showSearch
                size={'large'}
                placeholder={'Select city'}
                mode="multiple"
                value={city}
                onChange={handleCityId}
                style={{ width: 560 }}
                options={cityList}
                className={errorList['city_id']?.length > 0 ? 'borderRed' : ''}
              />
              {errorStatus && (
                <div className="subRecipeErrorMessages">
                  {errorList['city_id']}
                </div>
              )}
            </div>
            <Collapse
              className="supplierCollapseContainer"
              bordered={false}
              accordion
              defaultActiveKey={[0]}
              ghost
              expandIconPosition="right"
              style={{ marginTop: '2rem' }}
              // expandIcon={({ isActive }) =>
              //   isActive ? <img src={ArrowDown} /> : <img src={ArrowDown} />
              // }
            >
              {city?.map((data: any, index: number) => (
                <Panel
                  className="panelStyling"
                  key={index}
                  header={data?.label}
                >
                  <Checkbox.Group
                    value={deliveryTimes?.map(
                      (time: any) => time?.shop_id + time?.day
                    )}
                  >
                    {renderCheckboxGroup(data)}
                  </Checkbox.Group>
                </Panel>
              ))}
            </Collapse>
            <div className="butonGroup spacingForButtonGroup">
              <div className="wizard-button" onClick={() => handleBack()}>
                Back
              </div>
              <div
                className="continue wizard-button"
                onClick={() => handleContinue()}
              >
                Continue
              </div>
            </div>
          </div>
        </Page>
      </Spin>
    </React.Fragment>
  );
};

export default SupplyWizard;
